export default __webpack_public_path__ + "static/media/checkMarkFilled.84be19b2.svg";